import InvalidArgumentException from "Exceptions/invalidArgumentException";
import Vue from "Vue";
import axios from "axios";
import RequestException from "Exceptions/requestException";
import VueCookies from "vue-cookies";

Vue.use(VueCookies);
const tokenKey = "access_token";

const userDataUrl = "/api/account/getLogin";
const logOutUrl = "/api/account/logout";
const tokenUrl = "/api/account/token";
const registerUrl = "/api/account/register";

export default class Request {
	constructor() {

		let token = $cookies.get(tokenKey);

		let sendGetRequest = async function (url) {
			return await axios.get(url, {
				headers: {
					"Accept": "application/json",
					"Authorization": "Bearer " + token
				}
			}).then((result) => {
				return {
					success: true,
					value: result.data
				};
			}).catch((error) => {
				if (error.response.data !== undefined && error.response.data !== "") {
					console.error(new RequestException(logOutUrl), error.response.data);
					return {
						success: false,
						value: error.response.data.title
					};
				} else {
					console.error(new RequestException(logOutUrl), error.message);
					return {
						success: false,
						value: error.message
					};
				}
			});
		}

		let sendPostRequest = async function (url, data) {
			return await axios.post(url,
				JSON.stringify(data),
				{
					headers: {
						"Accept": "application/json",
						"Content-type": "application/json;charset=utf-8",
						"Authorization": "Bearer " + token
					}
				}).then((result) => {
					return {
						success: true,
						value: result.data
					};
				}).catch((error) => {
					if (error.response.data !== undefined && error.response.data !== "") {
						console.error(new RequestException(url), error.response.data);
						return {
							success: false,
							value: error.response.data.title
						};
					} else {
						console.error(new RequestException(url), error.message);
						return {
							success: false,
							value: error.message
						};
					}
				});
		}

		this.logOut = function () {
			axios.get(logOutUrl, {
				headers: {
					"Accept": "application/json",
					"Authorization": "Bearer " + token
				}
			}).then(() => {
				$cookies.remove(tokenKey);
			}).catch((error) => {
				if (error.response.data !== undefined && error.response.data !== "")
					console.error(new RequestException(logOutUrl), error.response.data);
				else
					console.error(new RequestException(logOutUrl), error.message);
			});
		}

		this.getUserInfo = async function () {
			return await axios.get(userDataUrl, {
				headers: {
					"Accept": "application/json",
					"Authorization": "Bearer " + token
				}
			}).then((response) => {
				let user = {
					userName: response.data,
					userLogged: true
				};
				return user;
			}).catch((error) => {
				if (error.response !== undefined && error.response.data !== undefined && error.response.data !== "")
					console.error(new RequestException(userDataUrl), error.response.data);
				else
					console.error(new RequestException(userDataUrl), error.message);

				return {
					userName: null,
					userLogged: false
				}
			});
		}

		this.getToken = async function (loginData) {
			return await axios.post(tokenUrl,
				JSON.stringify(loginData),
				{ headers: { "content-type": "application/json;charset=utf-8" } })
				.then(response => {
					$cookies.set(tokenKey, response.data.access_token, { expires: 365 }, null, null, true, "Lax");
					return {
						success: true,
						error: null,
						userName: response.data.username
					};
				}).catch(error => {
					if (error.response.data !== undefined && error.response.data !== "") {
						let data = error.response.data;
						let loginError = Array.isArray(data) ? error.response.data.join("<br />") : data;
						return {
							success: false,
							error: loginError,
							userName: null
						};
					}
					else {
						console.error(new RequestException(tokenUrl), error.message);
						return {
							success: false,
							error: error.message,
							userName: null
						};
					}
				});
		}

		this.sendRegistrationData = async function (formData) {
			return await axios.post(registerUrl,
				JSON.stringify(formData),
				{ headers: { "content-type": "application/json;charset=utf-8" } })
				.then(() => {
					return {
						success: true,
						error: null
					};
				}).catch(error => {
					if (error.response !== undefined &&
						error.response.data !== undefined &&
						error.response.data !== null) {
						let data = error.response.data;
						let errorTextSuffix = Array.isArray(data) ? error.response.data.join("<br />") : data;

						return {
							success: false,
							error: errorTextSuffix
						};
					} else {
						console.error(new RequestException(registerUrl), error.message);
						return {
							success: false,
							error: error.message
						};
					}
				});
		}

		this.getData = async function (url) {
			return await sendGetRequest(url)
				.then((result) => {
					return result;
				});
		}

		this.postData = async function (url, customer) {
			return await sendPostRequest(url, customer)
				.then((result) => {
					return result;
				});
		}
	}
}